export const courseStates = {
  normal: {
    value: 0,
    name: '正常上课',
    tagType: '',
  },
  late: {
    value: 1,
    name: '迟到',
    tagType: 'warning',
  },
  leaveEarly: {
    value: 2,
    name: '早退',
    tagType: 'warning',
  },
  lateAndLeaveEarly: {
    value: 3,
    name: '迟到并早退',
    tagType: 'warning',
  },
  leave: {
    value: 4,
    name: '请假',
    tagType: 'danger',
  },
};

export function findCourseState(courseStateValue) {
  for (const key in courseStates) {
    if (courseStateValue === courseStates[key].value) return [courseStates[key]];
  }
}
